import { init } from "../init";
import { AgileOverviewPage } from "../pages/agile/overview/agile-overview-page";
init(AgileOverviewPage);
